var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":"Daily Balance Activity"}},[_c('daily-balance-listings',{attrs:{"balance":_vm.balance,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }